const conditionStatement = {
  bindings: {
    index: '<',
    newBlock: '<',
    variables: '<',
    viewMode: '<',
    bracketMode: '<',
    startSelected: '<',
    endSelected: '<',
    onRemove: '&',
    onSave: '&',
    onEdit: '&',
  },
  templateUrl:
    '/modules/pis-tool/conditions/condition-form/condition-statement/condition-statement.html',
  controller: 'ConditionStatementController',
};

angular
  .module('pis-tool.module')
  .component('conditionStatement', conditionStatement);
